/**
 * OpenClaw 数字员工 API
 * 调用 im-platform 后端的 /bot/* 接口
 */
import http from './httpRequest.js';

/** 获取当前用户的数字员工列表 */
export function listBots() {
  return http({ url: '/bot/list', method: 'GET' });
}

/** 获取可用模型列表（通过用户的 sk token 从 OneAPI 获取） */
export async function listModels(tokenKey) {
  const oneapiBase = process.env.VUE_APP_ONEAPI_BASE || 'http://192.168.10.252:3002';
  const res = await fetch(`${oneapiBase}/v1/models`, {
    headers: { Authorization: `Bearer ${tokenKey}` },
  });
  if (!res.ok) return [];
  const data = await res.json();
  return (data.data || []).map(m => m.id).sort();
}

/** 创建数字员工 */
export function createBot(data) {
  return http({ url: '/bot/register', method: 'POST', data });
}

/** 刷新数字员工 token */
export function refreshBotToken(agentId) {
  return http({ url: `/bot/token/${agentId}`, method: 'POST' });
}

/** 删除数字员工 */
export function deleteBot(agentId) {
  return http({ url: `/bot/${agentId}`, method: 'DELETE' });
}

/** 获取用户设备列表 */
export function listDevices(userId) {
  return http({ url: `/device/list/${userId}`, method: 'GET' });
}

function buildCustomHostBase(device) {
  const customHost = (device?.customHost || '').trim();
  if (!customHost) return '';
  if (/^https?:\/\//i.test(customHost)) {
    return customHost.replace(/\/+$/, '');
  }
  return `${device.protocol || 'https'}://${customHost}`;
}

/** 根据设备 customHost 拼接网关地址 */
export async function probeGatewayUrl(device, token, timeout = 3000) {
  const base = buildCustomHostBase(device);
  const suffix = token ? `#token=${encodeURIComponent(token)}` : '';
  if (!base) return '';
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeout);
    await fetch(base, { mode: 'no-cors', signal: ctrl.signal });
    clearTimeout(timer);
  } catch (_) { /* fallback to customHost URL */ }
  return base + suffix;
}

/** 查询指定用户ID列表的在线终端 */
export function getOnlineTerminals(userIds) {
  return http({ url: '/user/terminal/online', method: 'GET', params: { userIds: userIds.join(',') } });
}
